/**
 * Zoho Books customers matching `search`, for the account-edit picker.
 *
 * Endpoint: GET /accounts/:uuid/integrations/zoho/contacts?search=
 * Needs ACCOUNT_PATCH_ZOHO. Answers `[{ contactId, contactName,
 * companyName, accountNo, email, linkedToOtherAccount }]`.
 */
export const fetchZohoContactsAction = ({ uuid, search }) => ({
  method: 'GET',
  endpoint: `/accounts/${uuid}/integrations/zoho/contacts?search=${encodeURIComponent(search)}`,
});
